import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Autoplay, Keyboard } from 'swiper/modules';
import { makeAllButCurrentSlideInert } from '../utilities/swiperAccessibility';
const $ = window.jQuery;


const $DOM = {};
let heroSwiperRestyle2024;

const domCache = () => {
    $DOM.container = $(".hero-slider-restyle-2024");
    if(!$DOM.container.length) {
        return;
    }
    $DOM.swiperContainer = $DOM.container.find(".swiper").first();
    $DOM.autoplayButton = $DOM.container.find(".js-play-button").first();
    $DOM.swiperIsLoop = $DOM.swiperContainer.find(".swiper-slide").length > 2;

}

const initSwiper = () => {
    heroSwiperRestyle2024 = new Swiper($DOM.swiperContainer[0], {
        modules: [Navigation, Pagination, A11y, Autoplay, Keyboard],
        init: false,
        slidesPerView: 1,
        spaceBetween: 48,
        speed: 750,
        preventClicksPropagation: false,
        roundLengths: true,
        centeredSlides: true,
        grabCursor: true,
        loop: $DOM.swiperIsLoop,
        // loopAdditionalSlides: $DOM.swiperIsLoop ? 1 : 0, // seems unnecessary
        a11y: true,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: false,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        watchOverflow: true,
        observer: true
    });


    heroSwiperRestyle2024.on("init", onInit);
    heroSwiperRestyle2024.init();

    // running activeIndexChange after init otherwise it triggers multiple times
    heroSwiperRestyle2024.on("activeIndexChange", onActiveIndexChange);

    $DOM.autoplayButton.on("click", function () {
        if (heroSwiperRestyle2024.autoplay.running) {
            heroSwiperRestyle2024.autoplay.stop();
        } else {
            heroSwiperRestyle2024.autoplay.start();
        }
        $(this).toggleClass("is-playing")
    })
}

const onInit = () => {
    $DOM.swiperContainer.addClass("is-init");
}

const onActiveIndexChange = (swiperInstance) => {
    makeAllButCurrentSlideInert(swiperInstance);
}

const heroSlider = {
    init: () => {
        domCache();
        if(!$DOM.container.length) {
            return;
        }
        // without the timeout swiper is initialized with disabled navigation buttons
        setTimeout(function () {
            initSwiper();
        },500);
    }
};

export default heroSlider;
